import React from 'react'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@/contexts/ThemeContext'
import { Link } from 'expo-router'

export default function GlobalFooter() {
  const { colors } = useTheme()

  const styles = StyleSheet.create({
    footer: {
      paddingHorizontal: 32,
      paddingVertical: 48,
      borderTopWidth: 1,
      borderTopColor: colors.border,
      backgroundColor: colors.surface,
    },
    footerContent: {
      alignItems: 'center',
      gap: 24,
    },
    footerLogo: {
      alignItems: 'center',
    },
    footerLogoText: {
      fontSize: 18,
      fontFamily: 'Inter-Bold',
      color: colors.text,
    },
    footerLinks: {
      flexDirection: 'row',
      gap: 40,
      alignItems: 'center',
    },
    footerLink: {
      fontSize: 14,
      fontFamily: 'Inter-Medium',
      color: colors.primary,
    },
    footerCopyright: {
      fontSize: 12,
      fontFamily: 'Inter-Regular',
      textAlign: 'center',
      color: colors.textSecondary,
    },
  })

  return (
    <View style={styles.footer}>
      <View style={styles.footerContent}>
        <View style={styles.footerLogo}>
          <Text style={styles.footerLogoText}>Põe no Racha</Text>
        </View>
        <View style={styles.footerLinks}>
          <Link href="/blog" asChild>
            <TouchableOpacity activeOpacity={0.7}>
              <Text style={styles.footerLink}>Blog</Text>
            </TouchableOpacity>
          </Link>
          <Link href="/sobre" asChild>
            <TouchableOpacity activeOpacity={0.7}>
              <Text style={styles.footerLink}>Sobre Nós</Text>
            </TouchableOpacity>
          </Link>
          <Link href="/termos-de-uso" asChild>
            <TouchableOpacity activeOpacity={0.7}>
              <Text style={styles.footerLink}>Termos de Uso</Text>
            </TouchableOpacity>
          </Link>
          <Link href="/politica-privacidade" asChild>
            <TouchableOpacity activeOpacity={0.7}>
              <Text style={styles.footerLink}>Política de Privacidade</Text>
            </TouchableOpacity>
          </Link>
          <Link href="/contato" asChild>
            <TouchableOpacity activeOpacity={0.7}>
              <Text style={styles.footerLink}>Contato</Text>
            </TouchableOpacity>
          </Link>
        </View>
        <Text style={styles.footerCopyright}>© 2025 Põe no Racha. Todos os direitos reservados.</Text>
      </View>
    </View>
  )
}
